import { render, staticRenderFns } from "./faq-question.vue?vue&type=template&id=abae4caa&scoped=true&"
import script from "./faq-question.vue?vue&type=script&lang=js&"
export * from "./faq-question.vue?vue&type=script&lang=js&"
import style0 from "./faq-question.vue?vue&type=style&index=0&id=abae4caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abae4caa",
  null
  
)

export default component.exports